import {
  BillExportEntity,
  BillExportParamsEntity,
} from "../../entities/BillExportEntity";
import { BillExportRepository } from "../../repositories/BillExportRepository";

export class DownloadBillExportExcelUseCase {
  constructor(private repository: BillExportRepository) {}

  async execute(params: BillExportParamsEntity = {}): Promise<BillExportEntity> {
    const from = params.fromDate?.trim() || "";
    const to = params.toDate?.trim() || "";

    if ((from && !to) || (!from && to)) {
      throw new Error("Please select both From date and To date.");
    }
    if (from && to && from > to) {
      throw new Error("From date must be before or equal to To date.");
    }

    return await this.repository.downloadBillExportExcel({
      fromDate: from || undefined,
      toDate: to || undefined,
    });
  }
}

